import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Checkbox, Col, Flex, Form, List, Row, Tag, TimePicker, } from "antd";
import FloatingModal from "../../../../components/common/FloatingModal";
import { BgWrapperEditorInput, InnerFormSection } from "../../editor.style";
import Icon from "../../../../components/common/Icon";
import { useRef, useState } from "react";
const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
const initialValue = {
    Sunday: { isOpen: false, is24Hours: false, timeRange: null },
    Monday: { isOpen: false, is24Hours: false, timeRange: null },
    Tuesday: { isOpen: false, is24Hours: false, timeRange: null },
    Wednesday: { isOpen: false, is24Hours: false, timeRange: null },
    Thursday: { isOpen: false, is24Hours: false, timeRange: null },
    Friday: { isOpen: false, is24Hours: false, timeRange: null },
    Saturday: { isOpen: false, is24Hours: false, timeRange: null },
};
const LocationHours = ({ value, onChange }) => {
    const [locationHoursModal] = Form.useForm();
    const [isModalVisible, setModalVisible] = useState(false);
    const handleCloseModal = () => {
        setModalVisible(false);
    };
    const handleAdd = () => {
        // const data = { locationState: "", stateType: undefined };
        setModalVisible(true);
        // locationHoursModal.setFieldsValue(data);
    };
    const refDiv = useRef(null);
    // Function to convert an array of moment objects to a date range string
    const sunday = Form.useWatch(['Sunday'], locationHoursModal);
    const monday = Form.useWatch(['Monday'], locationHoursModal);
    const tuesday = Form.useWatch(['Tuesday'], locationHoursModal);
    const wednesday = Form.useWatch(['Wednesday'], locationHoursModal);
    const thursday = Form.useWatch(['Thursday'], locationHoursModal);
    const friday = Form.useWatch(['Friday'], locationHoursModal);
    const saturday = Form.useWatch(['Saturday'], locationHoursModal);
    const formValues = [
        sunday,
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
    ];
    return (_jsxs(_Fragment, { children: [_jsxs(InnerFormSection, { ref: refDiv, children: [value && (_jsx(List, { children: _jsxs(List.Item, { children: [_jsx(List.Item.Meta, { title: "Hours", description: _jsx(Flex, { gap: 2, vertical: true, children: Object.entries(value).map(([day, { isOpen, is24Hours, timeRange }]) => {
                                            if (isOpen) {
                                                const formattedTime = timeRange
                                                    ? `${timeRange[0].format("h:mm a")}–${timeRange[1].format("h:mm a")}`
                                                    : "24 Hours";
                                                return (_jsxs("span", { children: [day, ": ", is24Hours ? "24 Hours" : formattedTime] }, day));
                                            }
                                            else {
                                                return _jsxs("span", { children: [day, ": Closed"] }, day);
                                            }
                                        }) }) }), _jsx(Button, { onClick: () => setModalVisible(true), variant: "text", size: "small", color: "default", icon: _jsx(Icon, { icon: "edit-02", size: 15 }) }), _jsx(Button, { onClick: () => onChange?.(null), variant: "text", size: "small", color: "danger", icon: _jsx(Icon, { icon: "trash-01", size: 15 }) })] }) })), !value && (_jsx(Button, { variant: "dashed", color: "default", block: true, icon: _jsx(Icon, { icon: "link-03", size: 15 }), iconPosition: "end", onClick: handleAdd, children: "Add Location Hours" }))] }), _jsxs(FloatingModal, { referenceDiv: refDiv, isVisible: !!isModalVisible, onClose: handleCloseModal, width: 800, children: [_jsx(Form, { form: locationHoursModal, onFinish: (value) => {
                            onChange?.(value);
                            setModalVisible(false);
                        }, layout: "vertical", initialValues: value, children: daysOfWeek.map((day, index) => {
                            const { isOpen, is24Hours } = formValues[index] || {};
                            return (_jsx(BgWrapperEditorInput, { style: { marginBottom: "10px" }, children: _jsxs(Row, { gutter: 20, align: "middle", children: [_jsx(Col, { flex: "2", children: _jsxs(Flex, { align: "center", gap: 1, children: [_jsx(Form.Item, { name: [day, "isOpen"], valuePropName: "checked", noStyle: true, children: _jsx(Checkbox, { children: day }) }), isOpen && (_jsx(Tag, { bordered: false, color: "success", children: "Open" }))] }) }), isOpen && (_jsxs(_Fragment, { children: [_jsx(Col, { children: _jsx(Form.Item, { name: [day, "is24Hours"], valuePropName: "checked", children: _jsx(Checkbox, { children: "Open 24 Hours" }) }) }), _jsx(Col, { flex: "3", children: !is24Hours && (_jsx(Flex, { align: "center", gap: 10, children: _jsx(Form.Item, { rules: [{ required: true }], name: [day, "timeRange"], children: _jsx(TimePicker.RangePicker, { placeholder: ["Opens at", "Closes at"], format: "HH:mm" }) }) })) })] }))] }) }, day));
                        }) }, JSON.stringify(value || { form: "" })), _jsxs(Flex, { justify: "flex-end", gap: 10, children: [_jsx(Button, { variant: "dashed", color: "default", onClick: handleCloseModal, children: "Close" }), _jsx(Button, { onClick: () => {
                                    locationHoursModal.submit();
                                }, color: "primary", variant: "solid", disabled: !formValues.filter((day) => day).some((day) => day.isOpen), children: "Add Hours" })] })] })] }));
};
export default LocationHours;
